export default {
  status: {
    open: "Abierto",
    in_progress: "En curso",
    waiting_response: "Esperando respuesta",
    resolved: "Resuelto",
    closed: "Cerrado",
  },
  priority: {
    "1": "Crítica",
    "2": "Alta",
    "3": "Media",
    "4": "Baja",
    "5": "Trivial",
  },
  category: {
    problem: "Problema",
    suggestion: "Sugerencia",
    improvement: "Mejora",
    question: "Pregunta",
    billing: "Facturación",
  },
} as const;
